import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    invoicesDetailsActivityTableData,
    invoicesDetailsTableData,
  } from "../../../assets/data/candidatesData";
import { dateFormator, formatWords, mapTableRows } from "../../../utils";
import companyLogo from "../../../assets/images/tektree-logo-png-1.svg";
import { Button, Divider, HeaderCard, InfoTimeCard, KeyValue, Modal, NewTable, PageHeader, PageTitle, StatusTags, Tag } from "../../../components";
import QbModal from "../Payments/payment/QbModal"
import ResendModal from "./payment/ResendModal";
import DeleteConformationModal from "./payment/DeleteConformationModal";
import VoidModal from "./payment/VoidModal";


const InvoiceDetails = ({ onBack, setReceivePayment, setEditInvoice }) => {
  const [isVoidModalOpen, setIsVoidModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isResendModal, setISResendModal] = useState(false);
  const [isQbModalOpen, setIsQbModalOpen] = useState(false);
  const [attachmentModal, setAttachmentModal] = useState(false);

  const navigate = useNavigate();

  const tableData = invoicesDetailsActivityTableData;
  const columns = [
    {
      key: "serviceSummary",
      label: "Service Summary",
    },
    {
      key: "activity",
      label: "Activity",
    },
    {
      key: "accountType",
      label: "Account Type",
    },
    {
      key: "attachment",
      label: "Attachment",
    },
    {
      key: "quantity(Hrs/Days)",
      label: "Quantity(Hrs/Days)",
    },
    {
      key: "rate",
      label: "Rate",
    },
    {
      key: "amount",
      label: "Amount",
    },
  ];

  const activityTableData = invoicesDetailsActivityTableData;
  const activityColumns = [
    {
      key: "dateAndTime",
      label: "Date & Time",
      render: (row) => dateFormator(row.dateAndTime, "datetime"),
    },
    {
      key: "description",
      label: "Description",
    },
    {
      key: "updatedBy",
      label: "UpdatedBy",
    },
  ];

  const mappedRows = mapTableRows(tableData, columns);
  const activityRows = mapTableRows(activityTableData, activityColumns);

  const closeVoidModal = () => {
    setIsVoidModalOpen(false);
  };
  return (
    <div className=" flex flex-col">
      <div className="flex justify-between mt-3 mb-6 items-center">
        <div></div>
        <div>
          <img src={companyLogo} alt="logo" />
        </div>
        <div>
          <p className="mb-1.5"> Invoice No: #16444</p>
          <div className="flex gap-2">
            <Tag
              title="Tektree"
              variant="outlined"
              color="black"
              className="!text-neutrals !py-1"
            />
            <StatusTags tag="Submitted" variant="text" icon />
          </div>
        </div>
      </div>
      <div>
        <PageHeader
          Section={
            <div className="flex">
              <InfoTimeCard
                title="Total Due"
                color="primary"
                value={"147833.72"}
                suffix={"USD"}
                type2
              />
            </div>
          }
          RightSection={
            <div className="flex gap-3">
              <Button
                size="sm"
                title={"Back"}
                icon={"arrow_left_alt"}
                onClick={onBack}
              />
              <Button
                size="sm"
                title={"Mail Sent"}
                icon={"docs"}
                onClick={() => navigate("/payments/add-payments/mail-sent")}
              />
              <Button
                size="sm"
                title={"Update to QB"}
                icon={"arrow_left_alt"}
                onClick={() => setIsQbModalOpen(true)}
              />
              <Button
                size="sm"
                title={"Void"}
                onClick={() => setIsVoidModalOpen(!isVoidModalOpen)}
              />
              <Button
                size="sm"
                title={"Delete"}
                onClick={() => setIsDeleteModalOpen(!isDeleteModalOpen)}
              />
            </div>
          }
        />
      </div>
      <div className="flex gap-3 mt-3 ">
        <HeaderCard title={"From"}>
          <KeyValue
            oneLine={false}
            label={"TekTree LLC"}
            value={[
              "1106 Drummond Plaza, Newark, DE 19711",
              "accounts@tektreeinc.com",
              "www.tektreeinc.com",
            ]}
          />
        </HeaderCard>
        <HeaderCard title={"To"}>
          <KeyValue
            oneLine={false}
            label={formatWords('--', "ShubhaMinds, LLC")}
            value={["10520 Chapell Hill road, #156", "Unnited States", "27560"]}
          />
        </HeaderCard>
        <HeaderCard title={"Invoice Details"}>
          <div className="flex flex-col gap-1">
            <KeyValue label={"Invoice"} value={"#16444"} />
            <KeyValue label={"Invoice Date"} value={"03/14/2025"} />
            <KeyValue label={"Shipped Date"} value={"03/14/2025"} />
            <KeyValue label={"Due Date"} value={"05/13/2025"} />
            <KeyValue label={"Class"} value={"Sukumar Mididodi"} />
            <KeyValue label={"Terms"} value={"Net 60"} />
          </div>
        </HeaderCard>
      </div>
      <div className="mt-3 shadow-md">
        <NewTable rows={mappedRows} columns={columns} hideToolBar showSlNo />
      </div>
      <div className="flex justify-end mt-4">
        <div className="bg-black text-white  flex gap-4 min-w-[400px] ">
          <div className="flex-1  justify-center text-center  border-white px-4 py-3">
            Subtotal
          </div>
          <div className="w-px bg-white mx-2" />
          <div className="flex-1 px-4 py-3">9600.00 USD</div>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <KeyValue
                  label={"Statement Memo"}
                  value={" Ramesh Manthri (02/01/2025 To 02/28/2025)"}
                />
                <KeyValue
                  label={"Statement Memo Period"}
                  value={"Ramesh Manthri (02/01/2025 To 02/28/2025)"}
                />
        
        
        <div className="flex">
                  <div className="border-[1px] border-neutrals-50 rounded-sm px-3 py-2 ">
                    <h6 className="font-medium ">Additional Info</h6>
                    <Divider />
                    <div className="mt-1  text-center py-3">
                      <KeyValue
                        value={[
                          "This Invoice has been Sold & Assigned to",
                          "Tek Tree LLC",
                          "Remit payment only to:",
                          "P.O Box #799",
                          "Gloucester, VA - 23061",
                          "C/O Chesapeake Bank",
                          "Chesapeake Bank",
                        ]}
                      />
                    </div>
                  </div>
                </div>
        <div className="mt-4">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"ATTACHMENTS"} tag="p" />
              </div>
            }
          />
          <Divider />
          <div className="mt-1 mb-4">
            <div className="flex gap-1">
              {/* <p>attachment 1</p> */}
              <div className="flex gap-3 mt-2">
                <div className="bg-info-50 flex rounded-md items-center">
                  <Button
                    icon="docs"
                    title={"Attachment 1.pdf"}
                    variant="text"
                    color="black"
                    size={"sm"}
                    onClick={() => setAttachmentModal(!attachmentModal)}
                  />
                </div>
                <div className="bg-info-50 flex rounded-md items-center">
                  <Button
                    icon="docs"
                    title={"Attachment 2.pdf"}
                    variant="text"
                    color="black"
                    size={"sm"}
                    onClick={() => setAttachmentModal(!attachmentModal)}
                  />
                </div>
                <div className="bg-info-50 flex rounded-md items-center">
                  <Button
                    icon="docs"
                    title={"Attachment 3.pdf"}
                    variant="text"
                    color="black"
                    size={"sm"}
                    onClick={() => setAttachmentModal(!attachmentModal)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-4">
          <PageHeader
            RightSection={
              <div className="flex">
                <div className="flex gap-3">
                  <Button
                    size="sm"
                    title={"Receive Payment"}
                    onClick={() => setReceivePayment(true)}
                  />
                  <Button
                    size="sm"
                    title={"Resend"}
                    onClick={() => setISResendModal(!isResendModal)}
                  />
                  <Button
                    size="sm"
                    title={"Edit"}
                    onClick={() => setEditInvoice(true)}
                  />
                  <Button size="sm" title={"Cancel"} />
                </div>
              </div>
            }
          />
        </div>
        <div>
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"ACTIVITIES"} tag="p" />
              </div>
            }
          />
          <Divider />
          <div className=" mt-4">
            <NewTable
              rows={activityRows}
              columns={activityColumns}
              hideToolBar
            />
          </div>
        </div>
      </div>
      <QbModal open={isQbModalOpen} onClose={() => setIsQbModalOpen(false)} />
      <VoidModal open={isVoidModalOpen} onClose={closeVoidModal} />
      <DeleteConformationModal
        open={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(!isDeleteModalOpen)}
      />
      <ResendModal
        open={isResendModal}
        onClose={() => setISResendModal(!isResendModal)}
      />
      <Modal
        isOpen={attachmentModal}
        onClose={() => setAttachmentModal(false)}
        title="Attachment View"
        width="max-w-5xl"
      >
        <div className="flex flex-col justify-center items-center gap-8">
          <h6>attachement Details</h6>

          <Button title={"Close"} onClick={() => setAttachmentModal(false)} />
        </div>
      </Modal>
    </div>
  );
};

export default InvoiceDetails;
